<!-- Bottom Navigation Bar -->
<nav class="bottom-nav" role="navigation" aria-label="Main navigation">
  @for (item of navItems; track item.route) {
    <button
      class="bottom-nav__item"
      [class.bottom-nav__item--active]="isActive(item)"
      (click)="navigate(item)"
      [attr.aria-label]="item.labelKey | translate"
      [attr.aria-current]="isActive(item) ? 'page' : null">
      <i [class]="item.icon" aria-hidden="true"></i>
      <span class="bottom-nav__label">{{ item.labelKey | translate }}</span>
    </button>
  }
</nav>
